/**
 * Stable CSS class names for E2E / automation — Cargo Prioritization.
 */
export const CPP = {
    page: 'cargo-prioritization-page',
    excelDownloadWrap: 'cargo-prioritization-page__excel-download',
    tableSection: 'cargo-prioritization-page__table-section',
    tableContainer: 'cargo-prioritization-page__table-container',
    saveActions: 'cargo-prioritization-page__save-actions',

    table: 'cargo-prioritization-table',
    tableHead: 'cargo-prioritization-table__head',
    tableBody: 'cargo-prioritization-table__body',
    cellBox: 'cargo-prioritization-table__cell-box',

    input: 'cargo-prioritization-input',
    inputButton: 'cargo-prioritization-input--button',
    inputTextfield: 'cargo-prioritization-input--textfield',
    inputSwitch: 'cargo-prioritization-input--switch',

    btnSave: 'cargo-prioritization-field--save',

    fieldRowPriority: 'cargo-prioritization-field--row-priority',
    fieldRowOrderLimit: 'cargo-prioritization-field--row-order-limit',
    fieldRedirectActive: 'cargo-prioritization-field--redirect-active',
    fieldCodRedirectActive: 'cargo-prioritization-field--cod-redirect-active',
} as const;

export const cppCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
